"use strict";
// import React from 'react'
// import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// import { fmtMs } from '../../utils/Utils';
// import { EndpointAgg } from '../../utils/api/orm-metrics/orm-metrics.type';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointBarChart = EndpointBarChart;
// export function EndpointBarChart({ data }: { data: EndpointAgg[] }) {
//   const top = data.slice(0, 10)
//   return (
//     <div style={{ width: '100%', height: 320 }}>
//       <ResponsiveContainer>
//         <BarChart 
//           layout="vertical" 
//           data={top} 
//           // margin={{ left: 40 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis type="number" tickFormatter={fmtMs} />
//           <YAxis type="category" dataKey={(d) => `${d.method} ${d.endpoint}`}  />
//           <Tooltip formatter={(val: any) => [fmtMs(val as number), 'Temps moyen SQL']} />
//           <Bar dataKey="avg_query_time_ms" name="Temps moyen SQL" />
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   )
// }
// import React, { useMemo } from 'react'
// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   Cell,
// } from 'recharts'
// import { fmtMs } from '../../utils/Utils'
// import { EndpointAgg } from '../../utils/api/orm-metrics/orm-metrics.type'
// type Props = {
//   data: EndpointAgg[]
//   /** hauteur du graph en px (default: 320) */
//   height?: number
//   /** nombre max d’items affichés (default: 10) */
//   maxBars?: number
//   /** palette de couleurs custom (hex ou rgba) */
//   palette?: string[]
// }
// const DEFAULT_PALETTE = [
//   '#4F8CFF', '#7C5CFC', '#3ECF8E', '#FF8C4F', '#FF5C93',
//   '#00C2FF', '#FFC44F', '#8ED1FC', '#C792EA', '#34D399',
//   '#F59E0B', '#EC4899', '#6EE7B7', '#A78BFA', '#60A5FA',
// ]
// /** Tronque un label long pour éviter la casse en mobile */
// function truncate(s: string, max = 28) {
//   return s.length > max ? s.slice(0, max - 1) + '…' : s
// }
// /** Tooltip custom, plus lisible */
// function CustomTooltip({ active, payload, label }: any) {
//   if (!active || !payload?.length) return null
//   const p = payload[0]
//   return (
//     <div
//       style={{
//         background: 'rgba(18,26,50,.95)',
//         color: '#E6EAF2',
//         padding: '10px 12px',
//         border: '1px solid #242d4a',
//         borderRadius: 10,
//         boxShadow: '0 8px 30px rgba(0,0,0,.35)',
//         fontSize: 12,
//       }}
//     >
//       <div style={{ opacity: .8, marginBottom: 6 }}>
//         {label}
//       </div>
//       <div><strong>Temps moyen SQL:</strong> {fmtMs(p?.value)}</div>
//     </div>
//   )
// }
// export function EndpointBarChart({
//   data,
//   height = 320,
//   maxBars = 10,
//   palette = DEFAULT_PALETTE,
// }: Props) {
//   // top N endpoints triés par temps SQL moyen (desc)
//   const top = useMemo(
//     () => [...data].sort((a, b) => (b.avg_query_time_ms ?? 0) - (a.avg_query_time_ms ?? 0)).slice(0, maxBars),
//     [data, maxBars]
//   )
//   // mappage couleur par ligne (stable par endpoint)
//   const colorsByKey = useMemo(() => {
//     const map = new Map<string, string>()
//     top.forEach((d, i) => {
//       const key = `${d.method} ${d.endpoint}`
//       map.set(key, palette[i % palette.length])
//     })
//     return map
//   }, [top, palette])
//   return (
//     <div style={{ width: '100%', height }}>
//       <ResponsiveContainer>
//         <BarChart
//           layout="vertical"
//           data={top}
//           barCategoryGap={12}
//           margin={{ top: 8, right: 24, bottom: 8, left: 12 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" opacity={0.25} />
//           <XAxis
//             type="number"
//             tickFormatter={fmtMs}
//             tick={{ fill: '#9aa4b2', fontSize: 12 }}
//             axisLine={{ stroke: '#242d4a' }}
//             tickLine={{ stroke: '#242d4a' }}
//           />
//           <YAxis
//             type="category"
//             dataKey={(d: EndpointAgg) => `${d.method} ${d.endpoint}`}
//             tickFormatter={(v: string) => truncate(v)}
//             tick={{ fill: '#c7cfe0', fontSize: 12 }}
//             width={200} // bon compromis; Recharts ajuste le reste
//             axisLine={{ stroke: '#242d4a' }}
//             tickLine={{ stroke: '#242d4a' }}
//           />
//           <Tooltip content={<CustomTooltip />} />
//           <Legend
//             verticalAlign="top"
//             wrapperStyle={{ paddingBottom: 6, color: '#9aa4b2' }}
//           />
//           <Bar
//             dataKey="avg_query_time_ms"
//             name="Temps moyen SQL"
//             radius={[6, 6, 6, 6]}
//           >
//             {top.map((d) => {
//               const key = `${d.method} ${d.endpoint}`
//               const fill = colorsByKey.get(key) || palette[0]
//               return <Cell key={key} fill={fill} />
//             })}
//           </Bar>
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   )
// }
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const Utils_1 = require("../../utils/Utils");
const DEFAULT_PALETTE = [
    '#4F8CFF', '#7C5CFC', '#3ECF8E', '#FF8C4F', '#FF5C93',
    '#00C2FF', '#FFC44F', '#8ED1FC', '#C792EA', '#34D399',
    '#F59E0B', '#EC4899', '#6EE7B7', '#A78BFA', '#60A5FA',
];
/** Tronque un label long pour éviter la casse en mobile */
function truncate(s, max = 28) {
    return s.length > max ? s.slice(0, max - 1) + '…' : s;
}
/** Tooltip custom, sécurisé (coercion en number) */
function CustomTooltip({ active, payload, label }) {
    var _a;
    if (!active || !(payload === null || payload === void 0 ? void 0 : payload.length))
        return null;
    const value = Number((_a = payload[0]) === null || _a === void 0 ? void 0 : _a.value);
    return (react_1.default.createElement("div", { style: {
            background: 'rgba(18,26,50,.95)',
            color: '#E6EAF2',
            padding: '10px 12px',
            border: '1px solid #242d4a',
            borderRadius: 10,
            boxShadow: '0 8px 30px rgba(0,0,0,.35)',
            fontSize: 12,
        } },
        react_1.default.createElement("div", { style: { opacity: .8, marginBottom: 6 } }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement("strong", null, "Temps moyen SQL:"),
            " ",
            (0, Utils_1.fmtMs)(value))));
}
function EndpointBarChart({ data, height = 320, maxBars = 10, palette = DEFAULT_PALETTE, }) {
    // Normalisation: on s'assure que avg_query_time_ms est un number
    const normalized = (0, react_1.useMemo)(() => {
        return (data !== null && data !== void 0 ? data : []).map(d => {
            var _a;
            return (Object.assign(Object.assign({}, d), { avg_query_time_ms: Number((_a = d.avg_query_time_ms) !== null && _a !== void 0 ? _a : 0) }));
        });
    }, [data]);
    // top N endpoints triés par temps SQL moyen (desc)
    const top = (0, react_1.useMemo)(() => [...normalized]
        .sort((a, b) => { var _a, _b; return ((_a = b.avg_query_time_ms) !== null && _a !== void 0 ? _a : 0) - ((_b = a.avg_query_time_ms) !== null && _b !== void 0 ? _b : 0); })
        .slice(0, maxBars), [normalized, maxBars]);
    // mappage couleur par ligne (stable par endpoint)
    const colorsByKey = (0, react_1.useMemo)(() => {
        const map = new Map();
        top.forEach((d, i) => {
            const key = `${d.method} ${d.endpoint}`;
            map.set(key, palette[i % palette.length]);
        });
        return map;
    }, [top, palette]);
    return (react_1.default.createElement("div", { style: { width: '100%', height } },
        react_1.default.createElement(recharts_1.ResponsiveContainer, null,
            react_1.default.createElement(recharts_1.BarChart, { layout: "vertical", data: top, barCategoryGap: 12, margin: { top: 8, right: 24, bottom: 8, left: 12 } },
                react_1.default.createElement(recharts_1.CartesianGrid, { strokeDasharray: "3 3", opacity: 0.25 }),
                react_1.default.createElement(recharts_1.XAxis, { type: "number", tickFormatter: (v) => (0, Utils_1.fmtMs)(Number(v)), tick: { fill: '#9aa4b2', fontSize: 12 }, axisLine: { stroke: '#242d4a' }, tickLine: { stroke: '#242d4a' } }),
                react_1.default.createElement(recharts_1.YAxis, { type: "category", dataKey: (d) => `${d.method} ${d.endpoint}`, tickFormatter: (v) => truncate(v), tick: { fill: '#c7cfe0', fontSize: 12 }, width: 200, axisLine: { stroke: '#242d4a' }, tickLine: { stroke: '#242d4a' } }),
                react_1.default.createElement(recharts_1.Tooltip, { content: react_1.default.createElement(CustomTooltip, null) }),
                react_1.default.createElement(recharts_1.Legend, { verticalAlign: "top", wrapperStyle: { paddingBottom: 6, color: '#9aa4b2' } }),
                react_1.default.createElement(recharts_1.Bar, { dataKey: "avg_query_time_ms", name: "Temps moyen SQL", radius: [6, 6, 6, 6] }, top.map((d) => {
                    const key = `${d.method} ${d.endpoint}`;
                    const fill = colorsByKey.get(key) || palette[0];
                    return react_1.default.createElement(recharts_1.Cell, { key: key, fill: fill });
                }))))));
}
